import {FC, ReactNode} from 'react'
import classNames from 'classnames'
import ActionButton from 'jbc-front/components/ActionButton'
import {Pulldown} from 'jbc-front/components/icons'
import styles from './MainFormControls.scss'

interface MainFormControlsProps {
  isExpand: boolean
  hasConditions: boolean
  onClear: () => void
  onToggleClick?: () => void
  children?: ReactNode
}

export const MainFormControls: FC<MainFormControlsProps> = ({
  isExpand,
  hasConditions,
  onClear,
  onToggleClick,
  children,
}) => {
  return (
    <div className={classNames(styles.mainFormControls, isExpand && styles.expanded)}>
      {children && <div className={styles.mainFormControl}>{children}</div>}
      <ActionButton
        primary={hasConditions}
        as="button"
        type="button"
        className={styles.mainFormControl}
        onClick={onClear}
      >
        条件解除
      </ActionButton>
      {onToggleClick && (
        <ActionButton
          primary={isExpand}
          as="button"
          type="button"
          className={styles.detailSearchButton}
          onClick={onToggleClick}
        >
          詳細検索
          <Pulldown size={18} className={isExpand ? styles.expandIconOpen : styles.expandIconClose} />
        </ActionButton>
      )}
    </div>
  )
}
